<template>
  <div class="follow-up follow-up--steps">
    <h3 class="mb-5">
      {{ data.title }}
    </h3>
    <ul>
      <li
        v-for="(step, index) in data.steps"
        :key="index"
        :class="{'active': isStepVisible(index)}"
        @click="onStepClick(index)"
      >
        <span class="backdrop" />
        <div class="d-none">
          {{ step.title }}
        </div>
        <div v-dompurify-html="step.body" />
        <div class="inner pt-3">
          <contact-button :data="step.form" />
          <contact-options
            :options="step.contact_options"
            :calculate-width="calculateWidth"
          />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import ContactButton from 'app/components/shared/contact-button'
import ContactOptions from 'app/components/shared/contact-options'

export default {
  name: 'Steps',
  components: {
    ContactButton,
    ContactOptions
  },
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      selectedIndex: 0,
      calculateWidth: false
    }
  },
  methods: {
    onStepClick (index) {
      this.selectedIndex = index
    },
    isStepVisible (index) {
      return this.selectedIndex === index
    }
  }
}
</script>
